export default "__VITE_ASSET__B4llIC$u__"